export default (i: string) => {
  return !!i && !isNaN(Number(i)) ? Math.floor(Number(i)) : i;
};
